import { Box, Button, DialogContentText } from '@mui/material';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import { MESSAGE } from '../../../constants/message';

const InactiveAreaTaxModal = ({
  open,
  onClose,
  title = MESSAGE.INACTIVE_AREA_TAX_LOCATION_WARNING_TITLE,
  description = MESSAGE.INACTIVE_AREA_TAX_LOCATION_WARNING_DESCRIPTION,
  actionLabel = MESSAGE.OK,
  onAction,
  buttonVariant = 'contained',
}) => {
  const handleAction = () => {
    if (onAction) {
      onAction();
      return;
    }
    onClose();
  };

  return (
    <Modal
      title={title}
      titleVariant="subtitle10"
      open={open}
      onClose={onClose}
      actionButtons={
        <Box my={3} display="flex" gap={2}>
          <Button size="large" variant={buttonVariant} onClick={handleAction}>
            {actionLabel}
          </Button>
          {onAction && (
            <Button size="large" variant="outlined" onClick={onClose}>
              {MESSAGE.CANCEL}
            </Button>
          )}
        </Box>
      }
    >
      <Box>
        <DialogContentText variant="body1">{description}</DialogContentText>
      </Box>
    </Modal>
  );
};

InactiveAreaTaxModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  buttonVariant: PropTypes.string,
};

export default InactiveAreaTaxModal;
